module.exports = __webpack_public_path__ + "img/botaosttrarcossetcemg.30352d0c.png";